import { type FlatAsset } from './order-box.types'
import { useTranslate } from '@repo/shared/hooks'
import { AspectRatio, Col, Icon, Row, Typography } from '@repo/ui/components'
import Image from 'next/image'
import { ValueWithUnit } from '..'
import { cn } from '@repo/ui/lib'

interface IOrderBoxAssetSelectSellItemProps {
  onClick: () => void
  //TODO separate for each app
  asset: FlatAsset
}

export const OrderBoxAssetSelectSellItem = (
  props: IOrderBoxAssetSelectSellItemProps,
) => {
  const { onClick, asset } = props
  const { t } = useTranslate()

  // Get the available amount
  const availableAmount = asset.availableBalance || asset.balance || 0

  // Get the token/unit display
  const getTokenDisplay = () => {
    if (asset.accountType === 'asset') {
      return 'SQ²'
    }
    // Check if it's MALEK token
    if (asset.currency === 'MALEK' || asset.token === 'MALEK') {
      return t('common_square_token_title')
    }
    return asset.name || asset.currency || ''
  }

  return (
    <div className='hover:bg-neutral-surface-5 cursor-pointer transition-colors duration-300'>
      <Row
        className='p-xs gap-md flex flex-row items-end w-full border-b border-neutral-surface-5 last:border-none cursor-pointer'
        onClick={onClick}
      >
        {/* Center - Asset info */}
        <Col className='flex-1 gap-xs'>
          <Row className='gap-md items-center'>
            {/* Project image or icon based on asset type */}
            {asset.image && asset.image !== '/images/placeholder.webp' ? (
              <div className='w-3xl h-3xl'>
                <AspectRatio className='aspect-1/1'>
                  <Image
                    src={asset.image}
                    alt='Project image'
                    fill
                    sizes='(max-width: 768px) 100vw, 32px'
                    className='h-full w-full rounded-2xs object-cover'
                    loading='lazy'
                  />
                </AspectRatio>
              </div>
            ) : asset.accountType === 'asset' ? (
              <div className='w-2xl h-2xl bg-primary-main rounded-2xs flex items-center justify-center'>
                <Icon name='SqMenu' size='xs' />
              </div>
            ) : (
              <div className='max-w-6 max-h-6'>
                <Image
                  src={
                    asset.token === 'MALEK'
                      ? '/images/club-gem.svg'
                      : '/images/placeholder.webp'
                  }
                  width={24}
                  height={24}
                  alt={asset.token === 'MALEK' ? 'Club Gem' : 'Placeholder'}
                  className={cn(
                    'object-cover max-w-6 max-h-6',
                    asset.token !== 'MALEK' && 'rounded-2xs',
                  )}
                />
              </div>
            )}
            <Col className='gap-2xs'>
              <Typography
                size='sm'
                color='text-neutral-surface-100'
                className='text-start'
              >
                {getTokenDisplay()}
              </Typography>
              <Row className='justify-between'>
                <Typography
                  size='xs'
                  color='text-neutral-surface-60'
                  className='text-start font-[AzarMehr]'
                >
                  {asset.token === 'MALEK' ? 'SQ²' : asset.token}
                </Typography>
                <Typography
                  size='sm'
                  color='text-neutral-surface-100'
                  weight='bold'
                >
                  <ValueWithUnit
                    value={availableAmount || 0}
                    unitSize='2xs'
                    valueSize='sm'
                    scale={asset.scale}
                    unit={asset.token === 'MALEK' ? 'SQ2' : asset.kind}
                  />
                </Typography>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
